<template>
    <div class='gradeDetail'>
        <GradeDetail :data="data"></GradeDetail>
        <div class="ftBtnBox" >
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>a
<script>
import Button from '@/components/Button.vue'
import GradeDetail from '@/components/consultant/GradeDetail.vue'
export default {
    name: "gradeAdd",
    components: {
        Button,
        GradeDetail
    },
    data() {
        return {
            data: {},
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
        }
    },
    created() {
        this.detailAchievementByStudent();
    },
    methods: {
        // 获取成绩列表
        detailAchievementByStudent(){
            let id = this.$route.query.id;
            this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.grade.detailAchievementByParent, {
                id:id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.data = res.data.data;
                }else{

                }
            })
        },
    },
}
</script>

<style scoped lang="less">
.gradeDetail {
    padding-bottom: 40px;
    font-size: 16px;
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>